import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTowerBroadcast } from '@fortawesome/pro-light-svg-icons/faTowerBroadcast';
import { faChartLine } from '@fortawesome/pro-light-svg-icons/faChartLine';
import { TypedMemo } from '../../common/types';
import { SMLButton } from '../components/primitives/SMLButton';
import { socialMessages as messages } from './socialMessages';
import { withBrandWord } from '../components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet per screen; each part of the screen uses its own slice of it */
import styles from './Social.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SocialPostsEmptyProps {
  /** `noChannel`: no channel is connected. `noPosts`: the period or the filters hold no post. */
  kind: 'noChannel' | 'noPosts';
  /** `noChannel`: opens Channels. `noPosts`: clears the filters; left out when no filter is set. */
  onAction?: () => void;
}

/** The two empty states of Performance (design social-connectors b3). */
const SocialPostsEmptyComponent: React.FC<SocialPostsEmptyProps> = ({ kind, onAction }) => {
  const intl = useIntl();
  const isNoChannel = kind === 'noChannel';

  return (
    <div className={clsx(styles.setupCard, !isNoChannel && styles.setupCardCentered)}>
      <span className={styles.setupIcon}>
        <FontAwesomeIcon icon={isNoChannel ? faTowerBroadcast : faChartLine} />
      </span>
      <div className={styles.setupText}>
        <b>{intl.formatMessage(isNoChannel ? messages.noChannelTitle : messages.noPostsTitle)}</b>
        <p>{withBrandWord(intl.formatMessage(isNoChannel ? messages.noChannelText : messages.noPostsText))}</p>
        {onAction === undefined ? null : (
          <SMLButton variant={isNoChannel ? 'primary' : 'default'} onClick={onAction}>
            {intl.formatMessage(isNoChannel ? messages.noChannelButton : messages.noPostsButton)}
          </SMLButton>
        )}
      </div>
    </div>
  );
};

export const SocialPostsEmpty = TypedMemo(SocialPostsEmptyComponent);
